const defaultAvatar = '/images/user.svg';
const teamDefaultLogo = '/images/default-team-logo.png';

export const MANUAL = 'https://imgameapp.ru/manual';
export const SUPPORT_URL = 'https://imgameapp.ru/#contacts';
export const LANDING_URL = 'https://imgameapp.ru/#organizer';
export const PRIVACY_POLICY_URL = 'https://imgameapp.ru/offer';
export const TERMS_AND_CONDITIONS_URL = 'https://imgameapp.ru/terms-and-conditions';
export const USER_DEFAULT_AVATAR = defaultAvatar;
export const TEAM_DEFAULT_LOGO = teamDefaultLogo;
